var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_730_67510)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_730_67510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7068 12L17.8004 6.9063C17.9958 6.71097 17.9958 6.39457 17.8004 6.1993C17.6051 6.00403 17.2887 6.00397 17.0934 6.1993L11.9998 11.293L6.90623 6.19923C6.7109 6.0039 6.3945 6.0039 6.19923 6.19923C6.00397 6.39457 6.0039 6.71097 6.19923 6.90623L11.2928 12L6.19923 17.0937C6.0039 17.289 6.0039 17.6054 6.19923 17.8007C6.2969 17.8984 6.42483 17.9472 6.55277 17.9472C6.6807 17.9472 6.80863 17.8984 6.9063 17.8007L11.9999 12.707L17.0935 17.8007C17.1912 17.8984 17.3191 17.9472 17.447 17.9472C17.575 17.9472 17.7029 17.8984 17.8006 17.8007C17.9959 17.6054 17.9959 17.289 17.8006 17.0937L12.7068 12Z",
    fill: "#757676"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_730_67510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_730_67510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/closeicon.9f02f910cc1d10be6e77719e1cf25975.svg";
export { ForwardRef as ReactComponent };